import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Theme } from '../../types'

interface ThemeState {
  theme: Theme
}

const initialState: ThemeState = {
  theme: 'system'
}

// Apply theme to document
const applyTheme = (theme: Theme) => {
  const root = document.documentElement
  // const systemTheme = window.matchMedia('(prefers-color-scheme: light)').matches ? 'dark' : 'light'
  const systemTheme = 'light'
  const effectiveTheme = theme === 'light' ? systemTheme : theme

  root.classList.remove('light', 'dark')
  root.classList.add(effectiveTheme)
}

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setTheme: (state, action: PayloadAction<Theme>) => {
      state.theme = action.payload
      applyTheme(action.payload)
    },
    toggleTheme: (state) => {
      const newTheme: Theme = state.theme === 'light' ? 'dark' : 'light'
      state.theme = newTheme
      applyTheme(newTheme)
    }
  }
})

export const { setTheme, toggleTheme } = themeSlice.actions
export default themeSlice.reducer 